module.exports = __webpack_public_path__ + "static/media/Rectangle180.6a5958e1.png";